import {priceAsc, priceDesc} from '~/utils/sort-helpers'

export default function (offers, sortFnName) {
    const sortFn = {
        priceAsc,
        priceDesc,
    }
    return offers.concat().sort((offer1, offer2) => sortFn[sortFnName](offer1, offer2))
}
